import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { AssetGalleryCardThumbnailImage } from "~/components/Gallery/AssetGalleryCard/AssetGalleryCardThumbnailImage";
export const BoardCollectionGalleryAssetThumbnail = /*#__PURE__*/ memo((param)=>{
    let { clip, width, height } = param;
    return /*#__PURE__*/ _jsx(AssetGalleryCardThumbnailImage, {
        ...clip,
        src: clip.assets.image,
        width: width,
        height: height
    });
});
BoardCollectionGalleryAssetThumbnail.displayName = "BoardCollectionGalleryAssetThumbnail";
